import styled, { css } from 'styled-components';

export const Container = styled.div`
    ${({ theme }) => css`
        border-radius: 0.5rem;
        background: ${theme.colors.tertiary.hex};
        padding: 0.75rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 1.5rem;
        }
    `}
`;

export const Top = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    row-gap: 1rem;
    flex-wrap: wrap;
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        margin: 0;
        color: ${theme.colors.primaryContrast.hex};
        font-size: 1.75rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.875rem;
        }
    `}
`;

export const EventsList = styled.ul`
    ${({ theme }) => css`
        margin: 1rem 0 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        list-style: none;

        @media ${theme.breakpoints.medium.media} {
            margin: 1.5rem 0 0;
            flex-wrap: nowrap;
            gap: 1.5rem;
        }
    `}
`;

export const ListItem = styled.li`
    ${({ theme }) => css`
        margin: 0;
        width: 100%;

        @media ${theme.breakpoints.medium.media} {
            width: calc(100% / 3);
        }
    `}
`;
